import React from 'react';
import { Item, Icon, Image } from 'semantic-ui-react';

import { AcceptedTypes } from '../../utils/attachmentTypes';
import { PDFThumbnail } from './PDFPreview';

const Thumbnail = ({ src, attachmentType, onClick }) => {
  if (!AcceptedTypes.includes(attachmentType))
    return <Icon size="huge" name="file" />;
  if (
    attachmentType === 'application/msword' ||
    attachmentType ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return <Icon size="huge" name="file word outline" />;
  }
  return (
    <Item.Image style={{ cursor: 'pointer' }} size="tiny" onClick={onClick}>
      {attachmentType === 'application/pdf' ? (
        <div
          style={{
            border: '1px solid #333333',
            overflowX: 'hidden',
            overflowY: 'hidden',
            maxWidth: '52px',
            maxHeight: '64px'
          }}
        >
          <PDFThumbnail id="pdf_thumbnail" src={src} scale={0.1} />
        </div>
      ) : (
        <Image src={src} />
      )}
    </Item.Image>
  );
};

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/component/DocumentPreview/Thumbnail.js